export default __webpack_public_path__ + "static/media/1090.dd0f71db.png";